import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {FilterService} from '@shared/models/filter-service.model';
import {Subject} from 'rxjs/Subject';
import {Appointments2FilterModel} from '../models/appointments2-filter.model';

@Injectable()
export class Appointments2FilterService implements FilterService {

	private filterSubject: Subject<Appointments2FilterModel> = new Subject<Appointments2FilterModel>();
	private filterObservable$: Observable<Appointments2FilterModel> = this.filterSubject.asObservable();
	private currentFilter: Appointments2FilterModel;
	private lastFilter: Appointments2FilterModel;

	getFilterObservable(): Observable<Appointments2FilterModel> {
		return this.filterObservable$;
	}

	updateFilter(filter: Appointments2FilterModel): void {
		this.currentFilter = filter;
		this.filterSubject.next(filter);
		if (this.currentFilter !== null) {
			this.lastFilter = this.currentFilter;
		}
	}

	getCurrentFilter(): Appointments2FilterModel {
		return this.currentFilter;
	}

	getEmptyFilter(): Appointments2FilterModel {
		return this.currentFilter = new Appointments2FilterModel();
	}

	reloadLastFilter(): void {
		this.updateFilter(this.lastFilter);
	}

}
